// Admin
import { PATCH_CLIENT_ERROR } from 'containers/Admin/Client/ClientSelection/constants'
import { PATCH_PARTNER_SITE_ERROR } from 'containers/Admin/PartnerSite/PartnerSiteSelection/constants'
import { POST_PRODUCT_ERROR } from 'containers/Admin/Product/ProductSelection/constants'
import { POST_USER_ERROR } from 'containers/Admin/User/UserSelection/constants'
import { POST_PARTNER_SITE_ERROR, DELETE_PARTNER_SITE_ERROR } from 'containers/Admin/Client/ClientSiteDialog/constants'
import { POST_LOGIN_USER_ERROR, UPDATE_SHOW_ERROR, CLEAR_SHOW_ERROR } from 'containers/User/Login/constants'

// Project
import { POST_UPLOAD_FILE_ERROR } from 'containers/Project/FileUploadDialog/constants'

export default Object.freeze([
  CLEAR_SHOW_ERROR,
  UPDATE_SHOW_ERROR,
  PATCH_CLIENT_ERROR,
  PATCH_PARTNER_SITE_ERROR,
  POST_PRODUCT_ERROR,
  POST_USER_ERROR,
  POST_PARTNER_SITE_ERROR,
  DELETE_PARTNER_SITE_ERROR,
  POST_UPLOAD_FILE_ERROR,
  POST_LOGIN_USER_ERROR
])
